module.exports = __webpack_public_path__ + "img/1256.573ae08d.gif";